import type { FaireProductEntity } from "../../entity_types/product";

export const p_h5ttrtuhr9: FaireProductEntity = {
  token: "p_h5ttrtuhr9",
  type: "product",
  name: "Japanese Onsen | Bergamot Neroli Cedarwood | Luxury Candle",
  brandToken: "b_ymy9myk6jv",
  brandName: "Kandlery",
  imageUrl:
    "https://cdn.faire.com/fastly/335555ac9d1fc152cee5374958a6f705188a0c9c13c51835a7f335923067a20f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58ec89003b51bbc79ecec5e22caa3add038c1762ce7e8f892e68173ecce2e9fb.jpeg",
    "https://cdn.faire.com/fastly/bedd03420b9c982a0938348cc1a6cc64a5ef1484a3d56aa099866d30512902cd.png",
    "https://cdn.faire.com/fastly/c64d46ed5ac523338e7f2b5922b97e4f3de70ebc7e55a9c6a787e6bdaef0b97a.png",
    "https://cdn.faire.com/fastly/b54d1ea91befb429216b1474c785262c74b3c201c19628da3b6d0396792d4de9.png",
    "https://cdn.faire.com/fastly/1882a8521b9c0f7ee4b98c46b8593764b9ffae89b9fd944937f1b233dc53f00c.png",
  ],
  priceDollars: 17.5,
  description:
    "Smells like a forest bathing in a Japanese onsen, with earthy calm, offering a soulful retreat into nature's haven.\n\n𝐓𝐨𝐩: Green foliage, Jasmine, Wild Bergamot\n𝐌𝐢𝐝𝐝𝐥𝐞: Fresh Neroli, No Mai Tse Lychee, Hosui Pear\n𝐁𝐚𝐬𝐞: Sun-Drenched Moss, Sheer Musk, Atlas Cedarwood\n\n𝐒𝐢𝐳𝐞 𝐨𝐩𝐭𝐢𝐨𝐧𝐬:\n9 oz. wood wicked gold tin with a lid\n\nNon-toxic | cruelty-free | pet-friendly\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\n𝐖𝐡𝐲 𝐊𝐚𝐧𝐝𝐥𝐞𝐫𝐲?\n• Natural Coconut Wax\n• Crackling Wooden Wick, Made from FSC Certified Wood.\n• Lead free & Self-trimming Cotton Wick\n• Non Toxic Ingredients\n• Premium Soothing Fragrances (Free of phthalate, reproductive toxins, and other concerning chemicals.)\n• Cruelty Free\n• Handcrafted in Small Batch\n• Untapped Asian-inspired scents",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:07.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
